import React from 'react';
export const Text = props => {
  const {
    param,
    update,
    data
  } = props;
  return <div className="form-group">
      <label>{param.label}</label>
      <input className="form-control" type="text" placeholder={param.placeholder} value={data[param.key] || ''} onChange={e => update({
      [param.key]: e.target.value
    })} />
    </div>;
};